/**
 * v6: `Redirect` removed; `Navigate` is the direct replacement. `replace`
 * added to match v5's default redirect behavior (v6's Navigate defaults to
 * push, which would otherwise change back-button behavior here).
 */
import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

const AuthProtected = ({ authorized }) => {
  if (!authorized) {
    return <Navigate to="/login" replace />;
  }
  return null;
};

AuthProtected.propTypes = {
  authorised: PropTypes.bool,
};

const mapStateToProps = state => ({
  authorized: state.auth.authorized,
});

export default connect(mapStateToProps)(AuthProtected);